'use client';

import React from 'react';
import { AuthContextType } from '@/types/auth';
import { DEFAULT_AUTH_CONTEXT_VALUE } from '@/constants/auth';
import { DEFAULT_CITY_CONTEXT_VALUE } from '@/constants/city';
import { DEFAULT_JOB_TITLE_CONTEXT_VALUE } from '@/constants/job-title';
import { CityContextType } from '@/types/city';
import { JobTitleContextType } from '@/types/job-title';

export const AuthContext = React.createContext<AuthContextType>(
  DEFAULT_AUTH_CONTEXT_VALUE,
);

export const JobTitleContext = React.createContext<JobTitleContextType>(
  DEFAULT_JOB_TITLE_CONTEXT_VALUE,
);

export const CityContext = React.createContext<CityContextType>(
  DEFAULT_CITY_CONTEXT_VALUE,
);
